<template>
    <div class="link-refresh">
        <a
            :href="linkUrl"
            v-if="linkTxt"
            class="link-refresh-a"
            target="_blank"
        >{{ $t(linkTxt) }}</a>
        <v-icon
            @click="refreshClick"
            class="link-refresh-btn"
            name="refresh"
        />
    </div>
</template>
<script>
export default {
    props: {
        linkUrl: {
            type: String,
            default: '/mng/role',
        },

        linkTxt: {
            type: String,
            // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
            default: '跳转角色页',
        },
    },

    data() {
        return {};
    },

    methods: {
        refreshClick() {
            this.$emit('refresh');
        },
    },
};
</script>

<style lang="less">
@import './index.less';
</style>
